export default "/assets/images/gamer-room-video-thumbnail.jpg?a93dbb33e95d9237073837b0bdd5091d";